











































import Vue from "vue";
import StatusLine from "./StatusLine.vue";

const stepOption = [
  { label: "10分钟", value: "10m" },
  { label: "30分钟", value: "30m" },
  { label: "1小时", value: "1h" },
  { label: "1天", value: "24h" }
];

function toFixed(value: number, index = 2) {
  if (!value && value !== 0) return "";
  return value.toFixed(index).replace(".".padEnd(index + 1, "0"), "");
}

const monitor = [
  {
    title: "内存使用情况(MB)",
    type: encodeURIComponent(
      "{__name__=~'(cluster_total_memory|cluster_allocatable_memory|cluster_pod_memory_usage)'}"
    ),
    legend: true,
    format: (value: string) => toFixed(parseFloat(value) / 1024 / 1024)
  },
  {
    title: "CPU平均负载(%)",
    type: encodeURIComponent(
      "{__name__=~'(cluster_load1|cluster_load5|cluster_load15)'}"
    ),
    legend: true,
    format: (value: string) => toFixed(parseFloat(value))
  },
  {
    title: "磁盘使用量(GB)",
    type: encodeURIComponent(
      "{__name__=~'(cluster_disk_size_usage|cluster_disk_size_capacity|cluster_disk_size_available)'}"
    ),
    legend: true,
    format: (value: string) => toFixed(parseFloat(value) / 1024 / 1024 / 1024)
  },
  {
    title: "磁盘吞吐量(MB/s)",
    type: encodeURIComponent(
      "{__name__=~'(cluster_disk_read_throughput|cluster_disk_write_throughput)'}"
    ),
    legend: true,
    format: (value: string) => toFixed(parseFloat(value) / 1024 / 1024)
  },
  {
    title: "inode使用率(%)",
    type: "cluster_disk_inode_utilisation",
    format: (value: string) => toFixed(parseFloat(value))
  },
  {
    title: "IPOS(次/s)",
    type: encodeURIComponent(
      "{__name__=~'(cluster_disk_read_iops|cluster_disk_write_iops)'}"
    ),
    legend: true,
    format: (value: string) => toFixed(parseFloat(value))
  },
  {
    title: "容器组运行状态",
    type: encodeURIComponent(
      "{__name__=~'(cluster_pod_running_count|cluster_pod_count|cluster_pod_abnormal_count)'}"
    ),
    legend: true,
    format: (value: string) => toFixed(parseFloat(value))
  }
];

export default Vue.extend({
  name: "Physical",
  components: { StatusLine },
  data() {
    return {
      date: [] as Array<Date>,
      step: "10m",
      stepOption,
      monitor
    };
  },
  mounted() {
    this.init();
    this.getData();
  },
  methods: {
    init() {
      const start = new Date();
      const end = new Date();

      start.setTime(start.getTime() - 3600 * 1000 * 2);
      // 默认选中 近两小时
      this.date = [start, end];
    },
    getData() {
      this.$nextTick(() => {
        (this.$refs.line as Vue[]).forEach(line => {
          (line as any).getData();
        });
      });
    },
    getDefaultData() {
      const now = new Date().getTime();
      switch (this.step) {
        case "10m":
          this.$set(this, "date", [
            new Date(now - 12 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "30m":
          this.$set(this, "date", [
            new Date(now - 24 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "1h":
          this.$set(this, "date", [
            new Date(now - 48 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "24h":
          this.$set(this, "date", [
            new Date(now - 24 * 7 * 3600 * 1000),
            new Date(now)
          ]);
          break;
      }
      this.getData();
    }
  }
});
